export enum LightShowTypeCodes {
  libraryTrack = '1A',
  videoWithLibraryTrack = '1B',
  customTrack = '2A',
  video = '2B'
}
